(function (angular) {
  "use strict";

  angular.module("app").controller("confirmController", confirmController);

  confirmController.$inject = ["$uibModalInstance", "$scope", "message"];

  function confirmController($uibModalInstance, $scope, message) {
    var vm = this;

    // properties
    vm.message = message || "Are you sure?";

    // methods
    vm.confirm = confirm;
    vm.cancel = cancel;

    function confirm() {
      $uibModalInstance.close(true);
    }

    function cancel() {
      $uibModalInstance.close(false);
    }

    // Catch the modal being closed by an outside click
    $scope.$on("modal.closing", function (event, reason, closed) {
      if (!closed) {
        $uibModalInstance.close(false);
      }
    });
  }
})(angular);
